import React, { PureComponent, Fragment } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEContainer, FHEDivider } from 'data/components';
import { Toastr } from 'data/common';
import { getInstallerDetails, resetPassword, updateInstallerDetails } from '../../data/Installers/actions';
import TableHomes from './Table/TableHomes';
import FormInstaller from './Form/FormInstaller';

class InstallerDetails extends PureComponent {
    static propTypes = {
        getInstallerDetails: PropTypes.func.isRequired,
        updateInstallerDetails: PropTypes.func.isRequired,
        resetPassword: PropTypes.func.isRequired,
        installerId: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getInstallerDetails();
    }

    getInstallerDetails = () => {
        const { getInstallerDetails, installerId } = this.props;

        this.setState({ loading: true, error: null });

        getInstallerDetails(installerId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    loading: false,
                    error: message
                });
            });
    };
    renderChildren = () => {
        const { updateInstallerDetails, resetPassword } = this.props;
        return (
            <Fragment>
                <FormInstaller
                    type="update"
                    sendDataFunc={updateInstallerDetails}
                    resetPassword={resetPassword}
                    renderOtherChildren={() => (
                        <Fragment>
                            <FHEDivider title={Translator.translate('generic.home.table.title')} />
                            <TableHomes />
                        </Fragment>
                    )}
                />
            </Fragment>
        );
    };

    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getInstallerDetails} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    return {
        profile: state.data.user,
        installerId: props.match.params.installerId,
        initialized: state.environments.fhe.data.Installers.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    activeColor: {
        color: theme.palette.success.main
    },
    inactiveColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getInstallerDetails, updateInstallerDetails, resetPassword }, dispatch)
    )(withStyles(styles, { withTheme: true })(InstallerDetails))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Installer/details.js